// SEO Ayarları — sayfa bazlı meta başlık / açıklama / anahtar kelimeler (components tablosu)
// Menüdeki öğeyle aynı yetki (ADMIN_CONFIG): Genel Yapılandırma'yı gören SEO Ayarları'nı da görür.
export default [
  {
    path: '/app/components',
    name: 'Components',
    component: () => import('@/views/Admin/Components/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'SEO Ayarları',
          active: true,
        },
      ],
      resource: 'ADMIN_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/app/components/edit/:id',
    name: 'ComponentEdit',
    component: () => import('@/views/Admin/Components/Edit.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'SEO Ayarları',
          to: '/app/components',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_CONFIG',
      action: 'read',
    },
  },
]
